// Ported verbatim from
// `@onestore/hel/dist/components/organisms/FullScreenContainerOrg/index.js`
// and `@onestore/hel/dist/components/organisms/PageHeaderOrg/components/settings.js`
// — these feed BaseSection's full-viewport-height offset math when rendered
// inside a `FullScreenContainerSection`.
export const FULL_SCREEN_CONTAINER_PADDING_UNIT_SMALL = 8
export const FULL_SCREEN_CONTAINER_PADDING_UNIT_LARGE = 24

const PAGE_HEADER_HEIGHT_SPACE_ON_MOBILE = 9
const PAGE_HEADER_HEIGHT_SPACE_ON_TABLET = 10.5
const PAGE_HEADER_HEIGHT_SPACE_ON_DESKTOP = 17

export const PAGE_HEADER_HEIGHT_UNIT = {
  small: PAGE_HEADER_HEIGHT_SPACE_ON_MOBILE * 8,
  medium: PAGE_HEADER_HEIGHT_SPACE_ON_TABLET * 8,
  large: PAGE_HEADER_HEIGHT_SPACE_ON_DESKTOP * 8,
}
